<template>
  <div class="container sd-center m-auto sd-login">
    <div class="text-center">
      <h1 class="h3">Reset Password</h1>
      <p>Please enter following details to reset your password</p>
    </div>
    <div class="row no-gutters sd-login__wrapper">
      <div class="col-lg-3 col-md-5 offset-lg-2 sd-login__map">
        <img src="@/assets/img/login_drone_on_map.svg" class="img-fluid" alt="Map Image">
      </div>
      <div class="col-lg-4 col-md-7 px-5 sd-login__form">
        <div class="text-center pt-4 pb-2">
          <img src="@/assets/img/logo_icon.svg" class="img-fluid" alt="">
        </div>
        <p class="text-primary sd-error-text h6 pt-2" v-html="resetError"></p>
        <form class="sd-form">
          <div class="form-group">
            <!-- <label for="loginPassword">Password</label> -->
            <div class="input-group sd-form__inputgroup">
              <div class="input-group-prepend">
                <span class="input-group-text sd-form__inputprepend sd-bg--gray">
                  <img src="@/assets/img/password_icon.svg" width="13px" class="img-fluid" alt="">
                </span>
              </div>
              <input type="password"
                    class="form-control sd-form__input sd-bg--gray"
                    placeholder="Current Password"
                    v-model="user.old_password">
            </div>
          </div>
          <div class="form-group">
            <!-- <label for="loginPassword">Password</label> -->
            <div class="input-group sd-form__inputgroup">
              <div class="input-group-prepend">
                <span class="input-group-text sd-form__inputprepend sd-bg--gray">
                  <img src="@/assets/img/password_icon.svg" width="13px" class="img-fluid" alt="">
                </span>
              </div>
              <input type="password"
                    class="form-control sd-form__input sd-bg--gray"
                    placeholder="New Password"
                    v-model="user.new_password">
            </div>
          </div>
          <div class="form-group">
            <!-- <label for="loginPassword">Password</label> -->
            <div class="input-group sd-form__inputgroup">
              <div class="input-group-prepend">
                <span class="input-group-text sd-form__inputprepend sd-bg--gray">
                  <img src="@/assets/img/password_icon.svg" width="13px" class="img-fluid" alt="">
                </span>
              </div>
              <input type="password"
                    class="form-control sd-form__input sd-bg--gray"
                    placeholder="Confirm Password"
                    v-model="repeatPassword">
            </div>
          </div>

          <button v-if="!showLoading" type="submit"
                  class="btn btn-primary text-uppercase sd-login__submit"
                  @click.prevent = "reset" >Reset</button>
          <button-spinner class="sd-spinner" v-else></button-spinner>
        </form>
      </div>
      </div>
  </div>
</template>

<script>
import spinner from '@/components/spinner.vue';
import api from '@/api';

export default {
  data() {
    return {
      user: {
        old_password: '',
        new_password: '',
      },
      repeatPassword: '',
      resetError: '',
      showLoading: false,
    };
  },
  components:{
  'button-spinner':spinner
  },
  created:function(){
   document.title="Skylark Drones Inspection Portal";
  },
  methods: {
    reset() {
      this.resetError = "";
      this.showLoading = true;

      if(this.user.new_password=== '' || this.user.old_password=== '' || this.repeatPassword === '') {
        this.resetError = "All are required fields";
        this.showLoading = false;
        return;
      }

      if(this.user.new_password != this.repeatPassword) {
        this.resetError = "New password and confirmation password doesn't match";
        this.showLoading = false;
        return;
      }

      api.resetPassword(this.user)
        .then((res) => {
          this.showLoading = false;
          if(res.status === 200) {
            this.resetError = "Password reset successful. Please login again.";
            this.showLoading = false;
            setTimeout(() => {
              this.$router.push({path:'Logout'});
            }, 3000);
          }
        })
        .catch((error) => {
          if (error.response.status === 400) {
            let errorMsg = '';
            if(error.response.data.old_password) {
              error.response.data.old_password.forEach((er) => {
                errorMsg += `</br> ${er}`;
              })
              this.resetError = errorMsg;
            } else if(error.response.data.new_password) {
              error.response.data.new_password.forEach((er) => {
                errorMsg += `</br> ${er}`;
              })              
              this.resetError = errorMsg;
            }
            this.showLoading = false;
          } else if (error.response.status === 500) {
            this.loginError = 'Internal Server Error. Please try again after sometime';
            this.showLoading = false;
          }
        });

    },
  },
};
</script>


<style lang="scss">

 @import '@/assets/sass/_variables.scss';

  .sd-center {
    position: absolute;
    top: 45%;
    left: 52%;
    transform: translate(-50%, -50%);
  }
  .sd-error-text {
    font-size: .8rem;
  }
  .sd-login{
    // padding-top: 10%;
    .sd-login__map{
    // box-shadow: 50px 50px 99px 0 rgba(0, 0, 0, 0.16);

        img{
        border-radius: .8rem 0 0 .8rem;
        box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);
        }
    }

    .sd-login__form{
        background-color: $white;
        border-radius: 0 .8rem .8rem 0;
        // box-shadow: 50px 50px 99px 0 rgba(0, 0, 0, 0.16);
        box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);
    }

    .sd-login__forgot {
        a {
        font-size: .8rem;
        font-weight: 500;
        color: $gray;
        }
    }

  .sd-login__submit{
    font-size: .8rem;
    font-weight: 500;
    letter-spacing: .09rem;
    }
  }
.sd-spinner{
  font-size:10px;
}
</style>
